import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const ViewIcon = ({ size = 15, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.5 5C8.5 4.17157 7.82843 3.5 7 3.5C6.17157 3.5 5.5 4.17157 5.5 5C5.5 5.82843 6.17157 6.5 7 6.5C7.82843 6.5 8.5 5.82843 8.5 5ZM10 5C10 6.65685 8.65685 8 7 8C5.34315 8 4 6.65685 4 5C4 3.34315 5.34315 2 7 2C8.65685 2 10 3.34315 10 5Z"
            fill={props.color || "currentColor"}
        />
        <path
            d="M6.99965 0C8.51145 0 9.87039 0.66247 10.9473 1.43485C12.0296 2.21114 12.8892 3.14265 13.4193 3.78418L13.42 3.78488C13.6456 4.05849 14 4.43615 14 5C14 5.56385 13.6456 5.94151 13.42 6.21512L13.4193 6.21582C12.8892 6.85735 12.0296 7.78886 10.9473 8.56515C9.87039 9.33753 8.51145 10 6.99965 10C5.48799 9.9999 4.12953 9.33747 3.05273 8.56515C1.97043 7.78886 1.1108 6.85735 0.580739 6.21582L0.580039 6.21512C0.354432 5.94151 0 5.56385 0 5C0 4.43615 0.354432 4.05849 0.580039 3.78488L0.580739 3.78418C1.1108 3.14265 1.97043 2.21114 3.05273 1.43485C4.12953 0.662527 5.48799 9.81945e-05 6.99965 0ZM6.99965 1.42857C5.90646 1.42867 4.8402 1.91233 3.88955 2.59417C2.94471 3.27184 2.1736 4.10186 1.68624 4.69169L1.68694 4.69238C1.61544 4.7791 1.5619 4.84389 1.51762 4.90095C1.48271 4.94593 1.46081 4.97751 1.44625 5C1.46081 5.02249 1.48271 5.05407 1.51762 5.09905C1.5619 5.15611 1.61544 5.2209 1.68694 5.30762H1.68624C2.17358 5.89747 2.94449 6.728 3.88955 7.40583C4.8402 8.08767 5.90646 8.57133 6.99965 8.57143C8.09296 8.57143 9.15971 8.08774 10.1104 7.40583C11.0553 6.72813 11.8257 5.89745 12.3131 5.30762L12.4824 5.09905C12.5171 5.05428 12.5385 5.02246 12.5531 5C12.5385 4.97754 12.5171 4.94572 12.4824 4.90095C12.4381 4.84389 12.3846 4.77909 12.3131 4.69238V4.69169C11.8257 4.10188 11.0551 3.27171 10.1104 2.59417C9.15971 1.91226 8.09296 1.42857 6.99965 1.42857Z"
            fill={props.color || "currentColor"}
        />
    </svg>
);
export default ViewIcon;
